import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import useGoogleAuthRedirect from '../../hooks/useGoogleAuthRedirect';

const SelectAge = () => {
    const { t } = useTranslation();

    const navigate = useNavigate()
    useGoogleAuthRedirect()

    const [selectedYear, setSelectedYear] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedDay, setSelectedDay] = useState('');
    const [daysInMonth, setDaysInMonth] = useState([]);
    const [calculatedAge, setCalculatedAge] = useState(null);

    const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    useEffect(() => {
        if (selectedYear && selectedMonth) {
            const days = new Date(selectedYear, selectedMonth, 0).getDate();
            const daysArray = Array.from({ length: days }, (_, i) => i + 1);
            setDaysInMonth(daysArray);
        }
    }, [selectedYear, selectedMonth]);

    useEffect(() => {
        if (selectedYear && selectedMonth && selectedDay) {
            const birthDate = new Date(selectedYear, selectedMonth - 1, selectedDay);
            const today = new Date();

            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();

            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            setCalculatedAge(age);
        }
    }, [selectedYear, selectedMonth, selectedDay]);

    console.log(selectedYear, selectedMonth, selectedDay);
    
    const [errors, setErrors] = useState({});
    const validate = () => {
        let errors = {};

        if (!selectedYear || !selectedMonth || !selectedDay) {
            errors.birthDate = "Please Select Your Birthdate."
        } 
    
        return errors;
    };
    const submitForm = async (e) => {
        e.preventDefault()
        const formErrors = validate();
        setErrors(formErrors);
        
        if (Object.keys(formErrors).length === 0) {
            const prevData = JSON.parse(localStorage.getItem('registerData')) || {};
            const updatedData = {
                ...prevData,
                birthDate: `${selectedYear}-${selectedMonth}-${selectedDay}`
            };
            localStorage.setItem('registerData', JSON.stringify(updatedData));
            if (prevData.userType === "parent") {
                navigate('/park/select-child-age')
            } else {
                navigate('/park/select-events')
            }
        }
        
    }

    return (
        <>
            <div className="light-theme">
                {/* { isLoading && <Loader /> } */}

                <div className='main-content'>
                    <div className='padding login-section'>
                        <div className='container'>
                            <div className='login-box mx-auto'>
                                <h4 className='text-center mb-1'>{t('What is your age?')}</h4>
                                <p className='text-center mb-5'>{t('Please Set Birthdate Below')}</p>
                                <form className='form form1' onSubmit={submitForm}>
                                    <div className="d-flex flex-wrap justify-content-center gap-2">
                                        {/* Year Selector */}
                                        <div className="text-center age">
                                            <select
                                                className="form-select no-arrow"
                                                style={{ width: "100px" }}
                                                value={selectedYear}
                                                onChange={(e) => setSelectedYear(e.target.value)}
                                            >
                                                <option value="" disabled>{'YEAR'}</option>
                                                {Array.from({ length: 80 }, (_, i) => {
                                                    const year = new Date().getFullYear() - i;
                                                    return <option key={year} value={year}>{year}</option>
                                                })}
                                            </select>
                                        </div>

                                        {/* Month Selector */}
                                        <div className="text-center age">
                                            <select
                                                className="form-select no-arrow"
                                                style={{ width: "100px" }}
                                                value={selectedMonth}
                                                onChange={(e) => setSelectedMonth(e.target.value)}
                                            >
                                                <option value="" disabled>{'MONTH'}</option>
                                                {monthNames.map((month, index) => (
                                                    <option key={index + 1} value={index + 1}>{month}</option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Day Selector */}
                                        <div className="text-center age">
                                            <select
                                                className="form-select no-arrow"
                                                style={{ width: "100px" }}
                                                value={selectedDay}
                                                onChange={(e) => setSelectedDay(e.target.value)}
                                            >
                                                <option value="" disabled>{'DAY'}</option>
                                                {daysInMonth.map((day) => (
                                                    <option key={day} value={day}>{day}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {errors.birthDate && <p className="error-text text-center mt-3">{errors.birthDate}</p> }

                                    {calculatedAge !== null && (
                                        <div className='mt-5 text-center'>
                                            <h4 className='mb-0'>WOW OLD FART, YOU’RE {calculatedAge}!</h4>
                                        </div>
                                    )}

                                    <div className='mt-5 pt-5'>
                                        <button type='submit' className='btn btn1 btn-border-main w-100 mt-4'>{t('NEXT')}</button>
                                    </div>
                                </form>

                                <p className='mb-0 text-center mt-5'>{t('Already have an account? Login')} <span className='text-black'><Link to="/park/signin" className='link text-decoration-underline fw-medium'>Login</Link></span></p>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SelectAge
